import React from "react";
import { Routes, Route } from "react-router-dom";
import { ClientsList } from "@/pages/Clients/ClientsList";

export const ClientsRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<ClientsList />} />
        </Routes>
    );
};

export { ClientsList };
